"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArnParts = exports.arnRegex = void 0;
const parts = [
    '^arn',
    ':',
    '(?<partition>.+?)?',
    ':',
    '(?<service>.+?)?',
    ':',
    '(?<region>(.+?))?',
    ':',
    '(?<accountId>(\\d{12}|aws))?',
    ':',
    '(?<resource>(.+?))?',
    '($|/|:(/\\S\+?){2}/|:)', // middle :(/\\S\+?){2}/ regex outs trailing /aws/lambda on log-groups
    '(?<instance>(.+?))?',
    '($|/|:)',
    '(?<suffix1>(.+?))?',
    '($|/|:)',
    '(?<suffix2>(.+?))?',
    '($|/|:)',
    '(?<suffix3>(.+?))?',
    '$',
];
exports.arnRegex = parts.join('');
const getArnParts = (arn) => new RegExp(exports.arnRegex).exec(arn)?.groups;
exports.getArnParts = getArnParts;
